module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n// Description: Clamp a number between a minimum and maximum value.\nfunction clamp(number, min, max) {\n    return Math.max(min, Math.min(number, max));\n}\n\nmodule.exports = clamp';

}
return __p
}